import { useTranslate } from '@tolgee/react';
import { MudInfoBox } from '@egov-moldova/mud-react';
import { formatExpiry } from '@simsm/ui-shared';
import './correction-review.css';

interface Props {
  medicine: string;
  lot: string;
  currentExpiry: string;
  // 'DAY' | 'MONTH': how the lot's expiry was reported (BUG-1-029).
  currentExpiryPrecision?: string | undefined;
  proposedExpiry: string;
  // The proposal is typed into the month field, so both request dialogs say
  // 'MONTH': it is read back as the month the operator entered.
  proposedExpiryPrecision?: string | undefined;
}

/**
 * caiet UC51-05 — "După confirmarea solicitării de corectare": the step between
 * the form and the submit, the same in both request dialogs
 * (docs/shape-ops-expiry-correction-gate.md D5). What will be filed, read back
 * once, and the wireframe's caption on what happens until the decision
 * (SolicitariCorectare.tsx: "Până la decizia AMDM, data de expirare rămâne
 * neschimbată.").
 */
export function CorrectionRequestReview({
  medicine,
  lot,
  currentExpiry,
  currentExpiryPrecision,
  proposedExpiry,
  proposedExpiryPrecision,
}: Props): JSX.Element {
  const { t } = useTranslate();
  return (
    <div className="simsm-correction-review">
      <p className="simsm-correction-review__lead">{t('correction_confirm.lead')}</p>
      <dl className="simsm-correction-review__facts">
        <div>
          <dt>{t('correction_confirm.field.medicine')}</dt>
          <dd>{medicine}</dd>
        </div>
        <div>
          <dt>{t('correction_confirm.field.lot')}</dt>
          <dd>{lot}</dd>
        </div>
        <div>
          <dt>{t('correction_confirm.field.current_expiry')}</dt>
          <dd>{formatExpiry(currentExpiry, currentExpiryPrecision)}</dd>
        </div>
        <div>
          <dt>{t('correction_confirm.field.proposed_expiry')}</dt>
          <dd className="simsm-correction-review__proposed">
            {formatExpiry(proposedExpiry, proposedExpiryPrecision)}
          </dd>
        </div>
      </dl>
      <MudInfoBox emphasis="strong" variant="info">
        {t('correction_confirm.note')}
      </MudInfoBox>
    </div>
  );
}
